import { Button, MenuItem, Select, Stack, Typography } from '@vapor/material'
import { FormItem } from 'hic-components'
import { useTranslation } from 'react-i18next'
import { PlanFragment } from 'src/api/api.generated'
import { PropertyTypeBuyNow } from '../buy-now.type'
import './style.css'
import parse from 'html-react-parser'

export default function StepTwo({
  plans,
  planIndex,
  selectedPlanReference,
  setSelectedPlanReference,
  propertyType,
  onBuy,
  disabled,
}: {
  plans: PlanFragment[] | null
  planIndex: number | null
  selectedPlanReference: string
  setSelectedPlanReference: (value: string) => void
  propertyType: PropertyTypeBuyNow
  onBuy: () => void
  disabled?: boolean
}) {
  const { t } = useTranslation()
  const selectedPlan = plans?.find((plan) => plan.title === selectedPlanReference) ?? null
  const footerFeatures = selectedPlan?.footerFeatures ?? plans?.[0]?.footerFeatures

  return (
    <>
      <Stack>
        <FormItem fieldLabel={<span id="select-resource-quantities">{t('pms.buy_now.drawer.stepper_2.label')}</span>}>
          <Select
            size="small"
            sx={{ maxWidth: '200px' }}
            value={selectedPlanReference}
            onChange={(event) => {
              setSelectedPlanReference(event.target.value as string)
            }}
            disabled={disabled}
          >
            <MenuItem value="NOT_SELECTED" disabled={planIndex !== null}></MenuItem>
            {plans?.map((plan, index) => (
              <MenuItem key={plan.title} value={plan.title} disabled={planIndex !== null ? index < planIndex : false}>
                {plan.title}
              </MenuItem>
            ))}
          </Select>
        </FormItem>
      </Stack>
      {selectedPlan !== null && (
        <Stack border={`3px solid var(--RichElectricBlue)`} padding={'32px'} borderRadius={'32px'} gap={2}>
          <Typography variant="titleSmall">{propertyType === 'appartment' ? t('pms.buy_now.drawer.stepper_2.buying_appartment') : t('pms.buy_now.drawer.stepper_2.buying_hotel')}</Typography>
          {selectedPlan.price ? (
            <Stack direction="row" gap={1} alignItems="end">
              <Typography variant="titleMedium" lineHeight={'24px'}>
                {selectedPlan.price} {selectedPlan.currency}
              </Typography>
              <Typography variant="caption">
                /{selectedPlan.billingFrequency?.toLocaleLowerCase() === 'annual' ? t('pms.buy_now.drawer.stepper_2.annual') : t('pms.buy_now.drawer.stepper_2.month')}
              </Typography>
            </Stack>
          ) : (
            <Typography variant="titleMedium" lineHeight={'24px'}>
              {t('pms.buy_now.drawer.stepper_2.personalized_price')}
            </Typography>
          )}
          <Typography variant="body">{propertyType === 'appartment' ? t('pms.buy_now.drawer.stepper_2.description_appartment') : t('pms.buy_now.drawer.stepper_2.description_hotel')}</Typography>
          <Stack>
            <Typography variant="titleXSmall">{t('pms.buy_now.drawer.stepper_2.what_is_included')}</Typography>
            <ul className="buy-now-check-icon">
              {(footerFeatures ?? []).map((feature, index) => (
                <li key={index}>{parse(feature.text)}</li>
              ))}
            </ul>
          </Stack>
          <Stack justifyContent="center" alignItems="center">
            <Button variant="contained" onClick={onBuy} disabled={disabled}>
              {t('pms.buy_now.drawer.stepper_2.buy')}
            </Button>
          </Stack>
        </Stack>
      )}
    </>
  )
}
